import { IExitForm } from '@/Models'
import { useFormContext } from 'react-hook-form'

interface PreviewProps {
  goToStep: (step: number) => void
}

export const PreviewComp = ({ goToStep }: PreviewProps) => {
  const { getValues } = useFormContext<IExitForm>()
  const data = getValues()

  return (
    <div className='shadow-sm- p-3 border rounded'>
      <h5 className='mb-4 fw-bold text-default'>Review Your Responses</h5>

      {/* employment info */}
      <section className='mb-4'>
        <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
          <strong className='text-secondary'>Employment Info</strong>
          <button className='btn btn-sm btn-outline-default' onClick={() => goToStep(1)}>
            Edit
          </button>
        </div>
        <ul className='list-group list-group-flush mt-3'>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Supervisor:</span> <span>{data.supervisorName}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Start Date:</span> <span>{data.employmentStartDate}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>End Date:</span> <span>{data.employmentEndDate}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Position:</span> <span>{data.currentPosition}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Returned Items:</span> <span>{data.returnOf?.join(', ')}</span>
          </li>
        </ul>
      </section>

      {/* exit details */}
      <section className='mb-4'>
        <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
          <strong className='text-secondary'>Exit Details</strong>
          <button className='btn btn-sm btn-outline-default' onClick={() => goToStep(2)}>
            Edit
          </button>
        </div>
        <ul className='list-group list-group-flush mt-3'>
          <li className='list-group-item d-flex justify-content-between'>
            <span className='text-start'>Reasons for Leaving:</span>{' '}
            <span>{data.reasonsForLeaving?.join(', ')}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>What Prompted Resignation:</span>{' '}
            <span>{data.specificEventPromptedResignation}</span>
          </li>
          <li
            onClick={() => goToStep(1)}
            className='list-group-item d-flex justify-content-between'
          >
            <span>Discussed with Supervisor:</span>{' '}
            <span>{data.discussedWithSupervisor === true ? 'Yes' : 'No'}</span>
          </li>
          <li className='list-group-item'>
            <div className='text-start'>Ratings:</div>
            <ul className='mt-2 ps-3 small'>
              {[
                ['trainingRating', 'Training Received'],
                ['supervisorRelationshipRating', 'Supervisor Relationship'],
                ['fellowEmployeesRelationshipRating', 'Coworker Relationship'],
                ['salaryRating', 'Salary Rating'],
                ['benefitsRating', 'Benefits Rating'],
                ['workloadRating', 'Workload Rating'],
                ['overallSatisfactionRating', 'Overall Satisfaction'],
              ].map(([key, label]) => (
                <li key={key} className='d-flex justify-content-between'>
                  <span>{label}</span>
                  <span>{(data as any)[key]}</span>
                </li>
              ))}
            </ul>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Laptop Password:</span> <span>{data.laptopPassword}</span>
          </li>
        </ul>
      </section>

      {/* final notes */}
      <section className='mb-2'>
        <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
          <strong className='text-secondary'>Final Notes</strong>
          <button className='btn btn-sm btn-outline-default' onClick={() => goToStep(3)}>
            Edit
          </button>
        </div>
        <ul className='list-group list-group-flush mt-3'>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Suggestion for Benefits:</span> <span>{data.benefitsComments}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Problems Encountered:</span> <span>{data.problemsEncountered}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Most Enjoyed thing at Tradegrid:</span> <span>{data.enjoyedMost}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Least Enjoyed thing at Tradegrid:</span> <span>{data.enjoyedLeast}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Would you Recommend Us:</span>{' '}
            <span>{data?.recommendEmployer === true ? 'Yes' : 'No'}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Would you Reapply:</span> <span>{data.wouldReapply === true ? 'Yes' : 'No'}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Explanation (if No to any above):</span>{' '}
            <span>{data.recommendEmployerExplanation}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Exit Interviewer:</span> <span>{data.exitInterviewConductedBy}</span>
          </li>
          <li className='list-group-item d-flex justify-content-between'>
            <span>Interview Date:</span> <span>{data.dateTime}</span>
          </li>
        </ul>
      </section>
    </div>
  )
}
